// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DocsPage_wrapper_2sr8I"};